export default __webpack_public_path__ + "static/media/home.749e3be1.jpg";